class Serving {
  static WHOLE = "whole";
  static RIGHT = "right";
  static LEFT = "left";

  constructor(type, label, cost) {
    this.id = type;
    this.cost = cost;
    this.label = label;
  }
}

export default Serving;


// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/PizzaCreatorModifiers/classes/Serving.js